
const TokenKey = 'Hear_Token'
const reTokenKey = 'Hear_reToken'

export function getToken () {
  return localStorage.getItem(TokenKey)
}
export function getreToken () {
  return localStorage.getItem(reTokenKey)
}

export function setToken (token) {
  return localStorage.setItem(TokenKey, token)
}
export function setreToken (retoken) {
  return localStorage.setItem(reTokenKey, retoken)
}

export function removeToken () {
  return localStorage.removeItem(TokenKey)
}
export function removereToken () {
  return localStorage.removeItem(reTokenKey)
}

// alioss
const accessKeyId = 'accessKeyId'
const accessKeySecret = 'accessKeySecret'
const stsToken = 'stsToken'
const expiration = 'expiration'

export function getaccessKeyId () {
  return localStorage.getItem(accessKeyId)
}
export function setaccessKeyId (val) {
  return localStorage.setItem(accessKeyId, val)
}

export function getaccessKeySecret () {
  return localStorage.getItem(accessKeySecret)
}
export function setaccessKeySecret (val) {
  return localStorage.setItem(accessKeySecret, val)
}
export function getexpiration () {
  return localStorage.getItem(expiration)
}
export function setexpiration (val) {
  return localStorage.setItem(expiration, val)
}
export function getstsToken () {
  return localStorage.getItem(stsToken)
}
export function setstsToken (val) {
  return localStorage.setItem(stsToken, val)
}

// 搭配商品信息
const dpgoods = 'Dp_list' // 搭配待加入商品
const dppagegoods = 'Dppg_list'// 搭配已加入的商品

export function getdpgoods () {
  return localStorage.getItem(dpgoods)
}
export function getredppagegoods () {
  return localStorage.getItem(dppagegoods)
}

export function setdpgoods (val) {
  return localStorage.setItem(dpgoods, val)
}
export function setredppagegoods (val) {
  return localStorage.setItem(dppagegoods, val)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js